import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: '#1060AF',
				secondary: '#8B1C11',
				accent: '#4FB3E5',
				error: '#b71c1c',
			},
			dark: {
				primary: '#FFFFFF',
			},
		},
	},
});
